export default class CountryModel {
	constructor(data = {}) {
		this.id = data.id;
		this.name = data.name;
		this.code = data.code;
	}
}
